import { render } from "./Trix.vue?vue&type=template&id=43d30452"
import script from "./Trix.vue?vue&type=script&lang=js"
export * from "./Trix.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ernes\\.ssh\\bipay-laravel-reportes\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Trix.vue"]])

export default __exports__